import React, { useEffect, useState } from 'react';
import { ChartRef } from '../_config/interface';
import { findLastIndex } from "lodash-es";

import './RadarPoint.scss';

interface IRadarPointProps {
  chartRef: React.RefObject<ChartRef>;
  option: any;
}

export default (props: IRadarPointProps) => {
  const { chartRef, option } = props;
  const [position, setPosition] = useState<{left: number; top: number;}>({left: 0, top: 0});
  const [showPoint, setShowPoint] = useState<boolean>(true);

  useEffect(() => {
    // 获取第一条线
    const firstLine = option?.series?.[0];
    // 获取第一条线的最后一个点的X坐标
    const lastX = findLastIndex(firstLine?.data, (item: any) => item);

    if (lastX < 0) {
      return;
    }
    // 获取第一条线的最后一个点的Y坐标
    const lastY = Number(firstLine?.data?.[lastX]?.value);
    // 获取chat实例
    const instance = chartRef?.current?.instance();

    // 更新坐标
    const updatePostion = (params?: any) => {
      const { type, name, selected } = params || {};
      if (type === 'legendselectchanged' && name === firstLine?.name ) {
        // 图例影藏直接返回
        if (!selected?.[name]) {
          setShowPoint(false);
          return;
        }
        setShowPoint(true);
      }
      // 获取最后一个点的坐标，相对于左上角
      const [left = 0, top = 0] = instance?.convertToPixel({xAxisIndex: 0, yAxisIndex: 0}, [lastX, lastY]) || [];
      // 判定最后一个点是否在坐标系内，dataZoom 开启时可能会在坐标系外
      const isInChart = instance?.containPixel({gridIndex: 0}, [left, top]);
      // console.log("params", params, lastX, left, top, isInChart);
      if (!isInChart) {
        setPosition({
          left: 0,
          top: 0
        });
        return;
      }
      setPosition({
        left: left || 0,
        top: top || 0
      });
      // console.log('RadarPoint useEffect point', lastX, lastY, lastPosition);
    };

    updatePostion();

    // dataZoom 事件
    instance?.on('dataZoom', updatePostion);
    // resize 事件
    instance?.on('finished', updatePostion);
    // legendselectchanged 事件,图例选中获取取消
    instance?.on('legendselectchanged', updatePostion);

    return () => {
      instance?.off('dataZoom', updatePostion);
      instance?.off('finished', updatePostion);
      instance?.off('legendselectchanged', updatePostion);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [option]);
  const { left, top } = position;
  const show = showPoint && (left || top);

  return <div className='dbd-radar-point-wrap' style={{left: `${left}px`, top: `${top}px`, visibility: show ? 'visible' : 'hidden'}}>
    <span style={{animationDelay: '0s'}}></span>
    <span style={{animationDelay: '1s'}}></span>
    <span style={{animationDelay: '2s'}}></span>
  </div>;
};
